import { isIOSAtom } from "../atoms";

/**
 * Hook to get the current iOS detection state
 * Returns true if the current device is iOS, false otherwise
 */
export function useIsIOS() {
  return isIOSAtom.useValue();
}